export default __webpack_public_path__ + "static/media/Twitter.aa59929c.png";